import { GetLeadsResponse } from './useGetLeads'

export const optimisticLeadsRefresh = async (
  currentData: GetLeadsResponse | undefined,
  identifiers: string[],
  is_read: boolean = true
) => {
  if (!currentData) return currentData

  const optimisticData = {
    ...currentData,
    collection: currentData.collection.map(currentLead => {
      if (identifiers.includes(currentLead.id)) {
        const readLead = {
          ...currentLead,
          attributes: { ...currentLead.attributes, is_read }
        }

        return readLead
      }

      return currentLead
    })
  }

  return optimisticData
}
